import { Box, CircularProgress, Divider, Typography } from "@mui/material"
import React from "react"
import { useSelector } from "react-redux"
import {
  HistoricalDataMonth,
  HistoricalDataValue,
  HistoricalDataWrapper,
  HistoricalHeadBox,
  HistoricalHeadBoxOne,
  HistoricalHeadBoxOneTypo,
  HistoricalHeadBoxTwo,
  HistoricalHeadBoxTwoTypo,
  HistoricalHeaderTypo,
  HistoricalLoadingWrapper,
  HistoricalWrapper,
} from "./Atom"
import { roundUp } from "../../../../helper/utils/formatting"
import { colors } from "../../../../styles/commonStyles"

const OpportunityDashboardHistorical = () => {
  const opportunityViewHistorical = useSelector((state: any) => {
    return state.metric.opportunityViewHistorical
  })

  return (
    <>
      {opportunityViewHistorical.length > 0 ? (
        <HistoricalWrapper>
          {opportunityViewHistorical.map((ele: any, eleIndex: any) => {
            return (
              <HistoricalHeaderTypo key={eleIndex}>
                {ele.opportunity}
              </HistoricalHeaderTypo>
            )
          })}
          <HistoricalHeadBox>
            <HistoricalHeadBoxOne>
              <HistoricalHeadBoxOneTypo>Month</HistoricalHeadBoxOneTypo>
            </HistoricalHeadBoxOne>
            <HistoricalHeadBoxTwo>
              {opportunityViewHistorical.map(
                (target: any, targetIndex: any) => {
                  return (
                    <HistoricalHeadBoxTwoTypo key={targetIndex} sx={{}}>
                      {target?.target_column_id?.replace(/_+/g, " ")}
                    </HistoricalHeadBoxTwoTypo>
                  )
                },
              )}
            </HistoricalHeadBoxTwo>
          </HistoricalHeadBox>
          <Box
            sx={{
              height: "300px",
              msOverflowY: "scroll",
              overflowY: "scroll",
              msOverflowStyle: "scrollbar",
            }}
            className="styled-scrollbar-vertical-broad"
          >
            {opportunityViewHistorical[0]?.monthly_historical?.map(
              (item: any, itemIndex: any) => {
                return (
                  <HistoricalDataWrapper>
                    <HistoricalDataMonth>{item.month}</HistoricalDataMonth>
                    <HistoricalDataValue
                      sx={{
                        backgroundColor:
                          item.color === null
                            ? ""
                            : item.color.toLowerCase() === "red"
                            ? colors.primaryRed
                            : item.color.toLowerCase() === "green"
                            ? colors.primaryGreen
                            : item.color.toLowerCase() === "yellow"
                            ? colors.primaryYellow
                            : "",
                        color:
                          item.color === null
                            ? ""
                            : item.color.toLowerCase() === "red"
                            ? colors.primaryWhite
                            : item.color.toLowerCase() === "green"
                            ? colors.primaryWhite
                            : item.color.toLowerCase() === "yellow"
                            ? colors.primaryBlack
                            : "",
                      }}
                    >
                      {item.value === null ? (
                        "N/A"
                      ) : (
                        <>{roundUp(item.value, item.datatype)}</>
                      )}
                      {/* {item.value === null ? (
                      "N/A"
                    ) : item.datatype === "%" ? (
                      <>
                        {item.value}
                        &nbsp;
                        {item.datatype}
                      </>
                    ) : (
                      <>
                        {item.datatype}
                        &nbsp;
                        {item.value}
                      </>
                    )} */}
                    </HistoricalDataValue>
                  </HistoricalDataWrapper>
                )
              },
            )}
          </Box>
        </HistoricalWrapper>
      ) : (
        <HistoricalLoadingWrapper>
          <CircularProgress />
        </HistoricalLoadingWrapper>
      )}
    </>
  )
}

export default OpportunityDashboardHistorical
